import { createFileRoute } from '@tanstack/react-router';

import { UsageSettingsPage } from '@/pages/settings/usage/UsageSettingsPage';

export const Route = createFileRoute('/_authenticated/_app/settings/usage')({
	component: UsageSettingsPage,
});
